/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @nx/enforce-module-boundaries */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Box, Typography, IconButton, useTheme } from '@mui/material';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import refresh from 'packages/novous_web/src/assets/icons/Refresh.svg';
import share from 'packages/novous_web/src/assets/icons/ShareWhite.svg';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import CallingModal from 'packages/novous_web/src/common/components/CallingModal';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import CameraButton from '../../pages/Dashboard/Trips/componenets/CameraButton';
import MP4VideoPlayer from '../../pages/Dashboard/Trips/componenets/Mp4VideoPlayer';
import VideoPlayer from '../../pages/Dashboard/Trips/componenets/VideoPlayer';
import { useLocation, useParams } from 'react-router-dom';
import AlertToast from './Alert';
import ExternalVideoPlayer from '../../pages/Dashboard/Trips/componenets/ExternalVideoPlayer';
import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';

interface CameraProps {
  cameraId: string;
  cameraName: string;
  playBackUrl: string;
  gForce?: [];
  alertTime?: string;
  alertData?: any;
  error?: string;
  message?: string;
}

interface LiveVideoExtModalProps {
  trip: any;
  vehicleId?: string;
  isDash?: boolean;
  onClose: () => void;
  user: any;
}

const LiveVideoExtModal: React.FC<LiveVideoExtModalProps> = ({ trip, vehicleId, isDash, onClose, user }) => {
  // ───── Token Validation Logic ─────────────
  const { vehicleRegNo } = useParams<{ vehicleRegNo: string }>();
  //const { blurValue } = useParams<{ blurValue: string }>();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const token = queryParams.get('token');
  const blurEnable = queryParams.get('blurEnable');
  const [isValidToken, setIsValidToken] = useState<boolean | null>(null);
  const [toast, setToast] = useState({ open: false, message: '', type: 'error' });
  const [deviceId, setDeviceId] = useState<string | undefined>(undefined);
  const [customerId, setCustomerId] = useState<string | undefined>(undefined);

  console.info('queryParams:', queryParams);

  console.info('Blur Value:', blurEnable);

  // Token validation API hook
  const { data: validTokenData, fetchData: fetchValidTokenData } = useAxios<{ data: any; message: string }>(
    token ? `${API_ENDPOINTS.dashboard.VALID_TOKEN}${token}` : '',
    'GET',
  );

  // Validate token on mount
  useEffect(() => {
    if (token) {
      fetchValidTokenData();
    } else {
      setIsValidToken(false);
    }
  }, [token]);

  // Process token validation response
  useEffect(() => {
    if (validTokenData) {
      if (
        validTokenData.data === null ||
        (Array.isArray(validTokenData.data) && validTokenData.data.length === 0)
      ) {
        setIsValidToken(false);
      } else {
        setIsValidToken(true);
      }
    }
  }, [validTokenData]);

  // Show token error toast when validation fails
  useEffect(() => {
    if (isValidToken === false) {
      setToast({
        open: true,
        message: 'Token validation unsuccessful',
        type: 'error',
      });
    }
  }, [isValidToken]);

  // ───── Existing component logic ─────────────
  const theme = useTheme();
  const videoContainerRef = useRef<HTMLDivElement>(null);
  const loadingRef = useRef(true);
  const [isDeviceOffline, setDeviceOffline] = useState({ show: false, message: '' });
  const [totalVideos, setTotalVideos] = useState<CameraProps[]>([]);
  const [liveVideo, setLiveVideo] = useState<CameraProps[]>([]);
  const [selected, setSelected] = useState(0);
  const [dimension, setDimension] = useState({ rowHeight: 0, rowWidth: 0 });
  const [callModalOpen, setCallModalOpen] = useState(false);
  const prevData = useRef(0);
  const [windowFullScreen, setWindowFullScreen] = useState(false);
  const [Activelist, setActiveList] = useState<CameraProps[][]>([]);
  const [fullModee, setFullModee] = useState(false);
  const [singleFullMode, setSingleFullMode] = useState(false);

  // New state for retry mechanism
  const [retryCount, setRetryCount] = useState(0);
  const MAX_RETRIES = 5;

  const networkPollRef = useRef<NodeJS.Timeout | null>(null);

  const getNetworkStyle = (strength: string) => {
    const normalized = strength?.trim().toLowerCase();
    switch (normalized) {
      case 'excellent':
        return { bgColor: 'rgba(39, 174, 96, 0.15)', textColor: '#219653' };
      case 'medium':
        return { bgColor: 'rgba(255, 193, 7, 0.15)', textColor: '#FFC107' };
      case 'low':
        return { bgColor: 'rgba(244, 67, 54, 0.15)', textColor: '#F44336' };
      default:
        return { bgColor: 'rgba(189, 189, 189, 0.15)', textColor: '#9E9E9E' };
    }
  };

  const { data: vehicleDetailsData, fetchData: fetchVehicleDetailsData } = useAxios<{
    data: { deviceId: string; customerId: string; dataSource: string };
  }>(vehicleRegNo ? `${API_ENDPOINTS.dashboard.GET_VEHICLE_DETAILS}${vehicleRegNo}` : '', 'GET');

  // Fetch vehicle details on mount or when vehicleRegNo changes
  useEffect(() => {
    if (vehicleRegNo) {
      fetchVehicleDetailsData();
    }
  }, [vehicleRegNo]);

  // Log the fetched vehicle details to the console
  // Log the fetched vehicle details to the console
  useEffect(() => {
    if (vehicleDetailsData) {
      console.info('Vehicle Details Data:', vehicleDetailsData);

      // Extract deviceId and set state
      const fetchedDeviceId = vehicleDetailsData?.data?.deviceId || undefined;
      setDeviceId(fetchedDeviceId);
      console.info('Device ID:', fetchedDeviceId);

      // Extract customerId and set state
      const fetchedCustomerId = vehicleDetailsData?.data?.customerId || undefined;
      setCustomerId(fetchedCustomerId);
      console.info('Customer ID:', fetchedCustomerId);
    }
  }, [vehicleDetailsData]);

  // Network strength API - only fetch if token is valid
  // const { data: vehicleCummunicationStrengthData, fetchData: fetchVehicleCummunicationStrengthData } =
  //   useAxios<{ data: string }>(
  //     `${API_ENDPOINTS.dashboard.NETWORKSTRENGTH}/${vehicleRegNo || vehicleId}`,
  //     'GET',
  //   );

  // useEffect(() => {
  //   if (isValidToken && (vehicleRegNo || vehicleId) && user?.id !== '685e1eec79b388464c5cd08e') {
  //     fetchVehicleCummunicationStrengthData();

  //     networkPollRef.current = setInterval(() => {
  //       fetchVehicleCummunicationStrengthData();
  //     }, 60000);
  //   }

  //   return () => {
  //     if (networkPollRef.current) {
  //       clearInterval(networkPollRef.current);
  //       networkPollRef.current = null;
  //     }
  //   };
  // }, [isValidToken, vehicleRegNo, vehicleId]);

  const [networkStrength, setNetworkStrength] = useState<string>('NA');

  useEffect(() => {
    if (isValidToken && (vehicleRegNo || vehicleId) && user?.id !== '685e1eec79b388464c5cd08e') {
      const currentVehicleId = trip?.vehicleRegNo || trip?.vehicleId;
      console.log('Current Vehicle ID:', currentVehicleId);

      if (!currentVehicleId) return;

      const socket = new SockJS(`${process.env.NX_PUBLIC_API_URL}/ws`);
      const stompClient = new Client({
        webSocketFactory: () => socket,
        onConnect: () => {
          console.log("WebSocket connected, subscribing to signals topic");
          stompClient.subscribe(`/topic/signals/${currentVehicleId}`, (message: { body: string }) => {
            try {
              const parsedMessage = JSON.parse(message.body);
              console.log("Received signal message:", parsedMessage);
              setNetworkStrength(parsedMessage.signalStrength || 'NA');
            } catch (error) {
              console.error("Error parsing WebSocket message:", error);
            }
          });
        },
        onStompError: (frame) => {
          console.error('WebSocket error:', frame);
        },
        onDisconnect: () => {
          console.log('WebSocket disconnected');
        }
      });

      stompClient.activate();

      return () => {
        console.log("🧹 Cleaning up WebSocket connection");
        stompClient.deactivate();
      };
    }
  }, [isValidToken, vehicleRegNo, vehicleId]);

  const strength = networkStrength;
  const { bgColor, textColor } = getNetworkStyle(strength);

  // Live stream API - only fetch if token is valid
  const {
    data: liveStreamData,
    error: liveStreamError,
    loading: liveStreamLoading,
    fetchData: fetchLiveStreamData,
    resetData: resetLiveStreamData,
    errorStatus: liveStreamErrorStatus,
  } = useAxios<{ data: CameraProps[]; message: string }>(
    vehicleRegNo ? `${API_ENDPOINTS.dashboard.LIVE_STREAM}${vehicleRegNo}` : '',
    'GET',
  );

  // Demo video API - only fetch if token is valid
  const { data: demoVideoUrls, fetchData: demoVideoUrlsRequestData } = useAxios<any>(
    `${API_ENDPOINTS.sdCard.DEMO_LIVE_STREAMING}/demo-device`,
    'GET',
  );

  // Reset retry count and data when a new vehicle is selected or on initial load
  useEffect(() => {
    if (isValidToken) {
      resetLiveStreamData();
      setDeviceOffline({ show: false, message: '' });
      setLiveVideo([]);
      setTotalVideos([]);
      prevData.current = 0;
      setRetryCount(0); // Reset the retry count for a new session
    }
  }, [vehicleRegNo, isValidToken]);

  // Main effect for fetching live stream data with retry logic
  useEffect(() => {
    if (!isValidToken || !vehicleRegNo) {
      return;
    }

    // For demo user, only call demo API once
    if (user?.id === '685e1eec79b388464c5cd08e') {
      if (!demoVideoUrls) {
        demoVideoUrlsRequestData();
      }
      loadingRef.current = false;
      return;
    }

    // Initial fetch for regular users
    if (liveStreamData === null && retryCount === 0) {
      loadingRef.current = true;
      fetchLiveStreamData();
      setRetryCount(1);
      return;
    }

    let timeoutId: NodeJS.Timeout | undefined;
    const hasStreams = Array.isArray(liveStreamData?.data);
    const streamsWithoutPlayBack = hasStreams
      ? liveStreamData.data.filter((item) => item.playBackUrl === '')
      : [];
    const allStreamsReady =
      hasStreams && streamsWithoutPlayBack.length === 0 && liveStreamData.data.length > 0;

    // Update video state if there's new data with playback URLs
    if (hasStreams) {
      const streamsWithPlayBack = liveStreamData.data.filter((item) => item.playBackUrl !== '');
      if (prevData.current !== streamsWithPlayBack.length) {
        prevData.current = streamsWithPlayBack.length;
        setLiveVideo([...streamsWithPlayBack]);
        setTotalVideos([...streamsWithPlayBack]);
        loadingRef.current = false;
      }
    }

    // Handle errors or initiate retries
    if (liveStreamError) {
      loadingRef.current = true;
      setDeviceOffline({ show: true, message: liveStreamError });
    } else if (!allStreamsReady && retryCount < MAX_RETRIES) {
      // If not all streams are ready and we haven't hit max retries, schedule another attempt
      timeoutId = setTimeout(() => {
        fetchLiveStreamData();
        setRetryCount((prev) => prev + 1);
      }, 2000);
    } else {
      // All streams are ready or max retries reached, stop loading
      loadingRef.current = false;
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [isValidToken, vehicleRegNo, liveStreamData, liveStreamError, fetchLiveStreamData, retryCount]);

  const cameraUrls: any[] = useMemo(() => {
    if (!demoVideoUrls?.data) return [[]];
    const filtered = demoVideoUrls.data.filter((item: any) => ['ADAS', 'DMS'].includes(item.cameraName));
    const mapped = filtered.map((item: any) => ({
      cameraId: item.cameraId.replace(/^0+/, ''),
      cameraName: item.cameraName,
      playBackUrl: item.playBackUrl,
    }));
    return [mapped];
  }, [JSON.stringify(demoVideoUrls?.data ?? [])]);

  const modifiedTripInfo = useMemo(() => {
    // Fallback to the original trip object if vehicleRegNo is not available from URL
    if (!vehicleRegNo) return trip;

    return {
      ...trip, // Spread existing trip properties
      vehicleRegNo: vehicleRegNo, // Override or add vehicleRegNo from URL
      vehicleId: vehicleRegNo, // Set vehicleId to be the same as vehicleRegNo as per instruction
    };
  }, [trip, vehicleRegNo]); // Dependencies: original trip object and URL vehicleRegNo

  const menuOptions = useMemo(() => {
    if (Array.isArray(liveStreamData?.data)) {
      return liveStreamData.data.map((item) => ({
        name: item.cameraName,
        onClick: () => handleCameraSelect(item.cameraName),
      }));
    }
    return [];
  }, [liveStreamData]);

  const handleCameraSelection = (name: string) => {
    if (name == 'All') {
      setSelected(0);
      if (totalVideos.length !== liveVideo.length) setTotalVideos(liveVideo);
    } else if (name == '2 Cam') {
      setSelected(2);
      const filterData = liveVideo.filter((item, index) => index < 2);
      if (totalVideos.length !== filterData.length) setTotalVideos(filterData);
    } else if (name == '4 Cam') {
      setSelected(4);
      const filterData = liveVideo.filter((item, index) => index < 4);
      if (totalVideos.length !== filterData.length) setTotalVideos(filterData);
    } else {
      setSelected(1);
    }
  };

  const handleCameraSelect = (name: string) => {
    // Camera selection logic
  };

  const handleCameraDropSelect = (cameraName: string, option: { name: string }) => {
    const filterData = liveStreamData?.data.filter((item) => item.cameraName === option.name);
    setTotalVideos(filterData || []);
  };

  const { rowArr, halfLength } = useMemo(() => {
    if (totalVideos.length === 0) return { rowArr: [], halfLength: 0 };
    let videos = [...totalVideos];

    if (videos.length > 2 && videos.length % 2 !== 0) {
      videos.push({ cameraId: '', cameraName: '', playBackUrl: '' });
    }

    const half = Math.ceil(videos.length / 2);
    const firstRow = videos.slice(0, half);
    const secondRow = videos.slice(half);
    const rows = videos.length === 2 ? [videos] : secondRow.length > 0 ? [firstRow, secondRow] : [firstRow];

    return { rowArr: rows, halfLength: half };
  }, [totalVideos]);

  // Removed useEffect that calculates dimension dynamically
  // Setting a static value for availableHeight and availableWidth
  const staticDimensions = { rowHeight: 500, rowWidth: 500 };

  useEffect(() => {
    setActiveList(rowArr);
  }, [rowArr]);

  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, []);

  const handleFullScreen = (cameraId: string) => {
    const element = document.getElementById('stream-subcontainer');
    if (element) {
      if (document.fullscreenElement) {
        document.exitFullscreen().then(() => {
          setWindowFullScreen(false);
          setFullModee(false);
          setActiveList(rowArr);
          setSingleFullMode(false);
        });
      } else {
        element.requestFullscreen().then(() => {
          setWindowFullScreen(true);
          setFullModee(true);
          setSingleFullMode(false);
          const filterArr = Activelist.filter((item) => {
            const itemArr: CameraProps[] = item.filter((video) => {
              if (video.cameraId == cameraId) {
                return video;
              }
            });
            if (itemArr.length > 0) {
              setActiveList([itemArr]);
              return true;
            } else {
              return false;
            }
          });
        });
      }
    }
  };

  const handleRefresh = () => {
    if (isValidToken && trip?.vehicleRegNo != '') {
      resetLiveStreamData();
      fetchLiveStreamData();
      prevData.current = 0;
      setRetryCount(0); // Reset retry count on manual refresh
    }
    loadingRef.current = true;
  };

  const handleCalling = () => setCallModalOpen(true);

  const selectedOption = totalVideos.length > 0 ? totalVideos[0].cameraName : 'FCW';

  // ───── Render based on token validity ─────────────
  if (isValidToken === null) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          width: '100%',
        }}
      >
        <Typography variant="h6">Validating token...</Typography>
      </Box>
    );
  }

  if (isValidToken === false) {
    return (
      <>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%',
          }}
        >
          {/* <Typography variant="h6">Token validation failed</Typography> */}
        </Box>
        <AlertToast
          open={toast.open}
          message={toast.message}
          onClose={() => setToast((prev) => ({ ...prev, open: false }))}
          type={toast.type as any}
        />
      </>
    );
  }

  return (
    <>
      <div className="flex flex-col h-full w-full max-w-[1200px] mx-auto gap-8">
        {/* Header */}
        <div className="flex justify-between items-center lg:flex-row md:flex-row sm:flex-col flex-col gap-4">
          <div className="flex flex-col">
            <Typography variant="h6">Live Streaming</Typography>
            <div className="flex gap-1">
              <Typography variant="body2" color="secondary" fontWeight={400}>
                Vehicle ID:
              </Typography>
              <Typography variant="body2">{vehicleRegNo || 'NA'}</Typography>
            </div>
          </div>
          <div className="flex gap-4">
            <div className="flex items-center gap-1">
              <Typography variant="caption" color="secondary">
                Network
              </Typography>
              <Box sx={{ backgroundColor: bgColor, px: '8px', py: '4px', borderRadius: '8px' }}>
                <Typography variant="overline" color={textColor} fontWeight={400}>
                  {strength}
                </Typography>
              </Box>
            </div>
            <CustomIconButton
              text="Refresh"
              icon={<img src={refresh} alt="refresh" />}
              background="transparent"
              variant="outlined"
              onClick={handleRefresh}
            />
            <CustomIconButton
              text="2 way Communication"
              outline
              padding="0px"
              variant="contained"
              onClick={handleCalling}
              isDisabled={liveStreamErrorStatus === '500' || (liveStreamLoading && loadingRef.current)}
            />
          </div>
        </div>

        {/* Video Grid */}
        <div className="flex flex-col gap-4 overflow-y-scroll h-full" ref={videoContainerRef}>
          {loadingRef.current && user?.id !== '685e1eec79b388464c5cd08e' ? (
            <div className="flex h-full justify-center items-center">
              {liveStreamLoading && (
                <Typography variant="h6" color="secondary">
                  Loading...
                </Typography>
              )}
              {liveStreamErrorStatus === '500' && <Typography variant="h6">{liveStreamError}</Typography>}
            </div>
          ) : user?.id === '685e1eec79b388464c5cd08e' ? (
            cameraUrls.map((row, rowIndex) => (
              <div
                key={rowIndex}
                className={`flex justify-center items-center h-full gap-4 lg:flex-row md:flex-row sm:flex-col flex-col lg:max-h-${staticDimensions.rowHeight} md:max-h-${staticDimensions.rowHeight} max-h-max`}
              // style={{ maxHeight: staticDimensions.rowHeight }}
              >
                {row.length === 0 && (
                  <Typography variant="body2" color="secondary" fontWeight={600} fontSize={36}>
                    Video will be available soon
                  </Typography>
                )}
                {row.map((video: any, index: any) => (
                  <div className="relative" key={index}>
                    {index === 0 && rowIndex === 0 && (
                      <div
                        className="flex gap-2 absolute lg:top-[4px] lg:left-[4px] md:top-[4px] md:left-[4px] sm:top-[20px] sm:left-[4px] top-[20px] left-[4px]"
                        style={{ zIndex: 99 }}
                      >
                        <CameraButton
                          handleClick={handleCameraSelection}
                          isSelected={selected === 0}
                          name="All"
                        />
                        <CameraButton
                          handleClick={handleCameraSelection}
                          isSelected={selected === 1}
                          name={selectedOption}
                          options={menuOptions}
                          onSelect={handleCameraDropSelect}
                        />
                        <CameraButton
                          handleClick={handleCameraSelection}
                          isSelected={selected === 2}
                          name="2 Cam"
                        />
                        <CameraButton
                          handleClick={handleCameraSelection}
                          isSelected={selected === 4}
                          name="4 Cam"
                        />
                      </div>
                    )}
                    <div className="relative" id="stream-subcontainer">
                      <MP4VideoPlayer
                        streamUrl={video.playBackUrl}
                        availableHeight={staticDimensions.rowHeight}
                        availableWidth={staticDimensions.rowWidth}
                        cameraId={video.cameraId}
                        fullMode={windowFullScreen}
                        cameraList={cameraUrls}
                        deviceId={deviceId}
                        customerId={customerId}
                        deviceType={vehicleDetailsData?.data?.dataSource}
                      />
                      <IconButton
                        color="primary"
                        className={`absolute ${windowFullScreen ? 'right-[95px]' : 'right-[45px]'}`}
                        size="small"
                        onClick={() => handleFullScreen(video?.cameraId)}
                        style={{
                          bottom: windowFullScreen ? '45px' : '30px',
                          position: 'absolute',
                          backgroundColor: 'white',
                          color: '#333',
                          zIndex: 100,
                        }}
                      >
                        {windowFullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
                      </IconButton>
                    </div>
                  </div>
                ))}
              </div>
            ))
          ) : (
            Activelist.map((row, rowIndex) => (
              <div
                key={rowIndex}
                className={`flex justify-center items-center h-full gap-4 lg:flex-row md:flex-row sm:flex-col flex-col lg:max-h-${staticDimensions.rowHeight} md:max-h-${staticDimensions.rowHeight} max-h-max`}
              // style={{ maxHeight: staticDimensions.rowHeight }}
              >
                {row.map((video, index) => (
                  <div className="relative" key={index}>
                    {index === 0 && rowIndex === 0 && (
                      <div
                        className="flex gap-2 absolute lg:top-[4px] lg:left-[4px] md:top-[4px] md:left-[4px] sm:top-[20px] sm:left-[4px] top-[20px] left-[4px]"
                        style={{ zIndex: 99 }}
                      >
                        <CameraButton
                          handleClick={handleCameraSelection}
                          isSelected={selected === 0}
                          name="All"
                        />
                        <CameraButton
                          handleClick={handleCameraSelection}
                          isSelected={selected === 1}
                          name={selectedOption}
                          options={menuOptions}
                          onSelect={handleCameraDropSelect}
                        />
                        <CameraButton
                          handleClick={handleCameraSelection}
                          isSelected={selected === 2}
                          name="2 Cam"
                        />
                        <CameraButton
                          handleClick={handleCameraSelection}
                          isSelected={selected === 4}
                          name="4 Cam"
                        />
                      </div>
                    )}
                    <div className="relative" id="stream-subcontainer">
                      {/* <VideoPlayer
                        streamUrl={video.playBackUrl}
                        availableHeight={staticDimensions.rowHeight}
                        availableWidth={staticDimensions.rowWidth}
                        cameraId={video.cameraId}
                        fullMode={windowFullScreen}
                        cameraList={Activelist}
                        deviceId={deviceId}
                        customerId={customerId}
                        fetchBlurFalse={true}
                        blurEnable={blurEnable === 'true' ? true : false}
                        deviceType={vehicleDetailsData?.data?.dataSource}
                      /> */}
                      <ExternalVideoPlayer
                        streamUrl={video.playBackUrl}
                        availableHeight={staticDimensions.rowHeight}
                        availableWidth={staticDimensions.rowWidth}
                        cameraId={video.cameraId}
                        fullMode={windowFullScreen}
                        cameraList={Activelist}
                        deviceId={deviceId}
                        customerId={customerId}
                        fetchBlurFalse={true}
                        blurEnable={blurEnable === 'true' ? true : false}
                        deviceType={vehicleDetailsData?.data?.dataSource}
                      />
                      <IconButton
                        color="primary"
                        className={`absolute ${windowFullScreen ? 'right-[95px]' : 'right-[45px]'}`}
                        size="small"
                        onClick={() => handleFullScreen(video.cameraId)}
                        style={{
                          bottom: windowFullScreen ? '45px' : '30px',
                          position: 'absolute',
                          backgroundColor: 'white',
                          color: '#333',
                          zIndex: 100,
                        }}
                      >
                        {windowFullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
                      </IconButton>
                    </div>
                  </div>
                ))}
              </div>
            ))
          )}
        </div>
      </div>

      <CallingModal
        tripInfo={modifiedTripInfo}
        open={callModalOpen}
        onClose={() => setCallModalOpen(false)}
      />
      <AlertToast
        open={toast.open}
        message={toast.message}
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
        type={toast.type as any}
      />
    </>
  );
};

export default LiveVideoExtModal;
